// gets an item based on its id, then plucode
export default (
  items: Items,
  options: { id?: string; name?: string; plucode?: string },
) => {
  let item;

  if (options.id != null) {
    item = items[String(options.id)];
  }

  if (!item && options.plucode) {
    item = Object.values(items).find(val => val.plucode === options.plucode);
  }

  // Note: Removed name-based lookup to prevent incorrect item substitutions.

  return item;
};
